export {default} from './BrainableLayout'
